import { connect } from 'react-redux';
import { changeView, incScratcherPos, selectChoice } from '../../../actions/actions';
import QuestionsList from './QuestionsList';

const mapStateToProps = (state) => {
  return {
    view: state.view,
    scratcherPosition: state.scratcherPosition,
    questions: state.questions,
    numberOfQuestions: state.numberOfQuestions,
    sessionId: state.sessionId,
    userId: state.userId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeView: (view, prev) => {
      dispatch(changeView(view, prev));
    },
    incScratcherPos: () => {
      dispatch(incScratcherPos());
    },
    selectChoice: (answer, personality, pos, numberOfQuestions, selection, userId, sessionId, questionId) => {
      dispatch(selectChoice(answer, personality, pos, numberOfQuestions, selection, userId, sessionId, questionId));
    }
  };
};

const QuestionsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionsList);

export default QuestionsListContainer;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Questions/QuestionsListContainer.js
 **/